module.exports = __webpack_public_path__ + "static/media/info_test.5bae16d9.png";